import React from "react"
import Responsive from "react-responsive"

import Info from "./Info"

const Desktop = props => <Responsive {...props} minWidth={1000} />
const Mobile = props => <Responsive {...props} maxWidth={999} />

const Homepage = () => {
  return (
    <section className="homepage">
      <div className="homepage-img">
        <Desktop>
          <img
            className="homepage-img-desktop"
            src="/images/Homepage/app-homepage-desktop.svg"
            alt="DigiWall app homepage desktop"
          />
        </Desktop>
        <Mobile>
          <img
            className="homepage-img-mobile"
            src="/images/Homepage/app-homepage-mobile.svg"
            alt="DigiWall app homepage mobile"
          />
        </Mobile>
      </div>

      <div className="homepage-info">
        <Info />
      </div>
    </section>
  )
}

export default Homepage
